import React, { useEffect } from 'react'
import './Journey_within.css'
import Common_Back_Header from '../../../../common/common_components/common_back_header/Common_Back_Header'
import Common_Title_1 from '../../../../common/common_components/common_title_1/Common_Title_1'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { myAccount, myEventRegistration } from '../../../../../features/my_account/Slice'
import { IDS } from '../../../../../utils/IDS'
const Journey_within = () => {

    const dispatch = useDispatch();

    const registrations = useSelector((state) => state.myaccount.event_registrations);

    useEffect(() => {
        dispatch(myEventRegistration());
    }, [dispatch]);



    const calculateDailyEventHours = (
        startDate, // "YYYY-MM-DD"
        endDate,   // "YYYY-MM-DD"
        startTime, // "HH:mm"
        endTime    // "HH:mm"
    ) => {


        if (!startDate || !endDate || !startTime || !endTime) return 0;

        const dailyStart = new Date(`1970-01-01T${startTime}`);
        const dailyEnd = new Date(`1970-01-01T${endTime}`);

        if (dailyEnd <= dailyStart) return 0;

        const dailyHours =
            (dailyEnd - dailyStart) / (1000 * 60 * 60);

        // Calculate number of days (inclusive)
        const start = new Date(startDate);
        const end = new Date(endDate);

        const dayDiff = Math.floor((end - start) / (1000 * 60 * 60 * 24)) + 1;

        if (dayDiff <= 0) return 0;

        const totalHours = dailyHours * dayDiff;

        return Number(Math.round(totalHours));
    };

    const calculateDays = (
        startDate, // "YYYY-MM-DD"
        endDate,   // "YYYY-MM-DD"
    ) => {

        if (!startDate || !endDate) return 0;
        const start = new Date(startDate);
        const end = new Date(endDate);

        const dayDiff = Math.floor((end - start) / (1000 * 60 * 60 * 24)) + 1;

        if (dayDiff <= 0) return 0;

        return Number(Math.round(dayDiff));
    };





    return (
        <>
            <section className='Journey_within_sec'>
                <div className='container'>
                    <Common_Back_Header backNavigation={-1} />
                    <div className='banner_div'>
                        <img className='banner_img' src={process.env.PUBLIC_URL + '/assets/images/profile/journey/banner.png'} />
                    </div>
                    <h4 className='congh4'>Congrats, You are 3 steps away to reach divinity!</h4>

                    <div className='shibir_cards_sec'>
                        {registrations?.data?.map((data) => (
                            <div className='shibir_card'>
                                <div className='titlediv'>
                                    <div className='name_div'>
                                        <p className='shibname'>{data?.Event?.name || "--"}</p>
                                    </div>
                                    <div className='img_div'>
                                        <img className='gold_icon' src={process.env.PUBLIC_URL + '/assets/images/profile/journey/gold.png'} />
                                    </div>
                                </div>

                                <div className='body'>
                                    <div className='imgsec'>
                                        <img className='maharajimg' src={IDS.IMG_URL + data?.Event?.image} />
                                        {/* <img className='maharajimg' src={process.env.PUBLIC_URL + '/assets/images/profile/journey/maharaj.png'} /> */}
                                    </div>
                                    <div className='contentsec'>
                                        <p className='ptitle'> {data?.Event_Attendances?.length || "0"}  /  {data?.Event?.total_days || "--"}  Sessions Completed</p>
                                        <p className='ptitle'>{calculateDailyEventHours(data?.Event?.start_date, data?.Event?.end_date, data?.Event?.start_time, data?.Event?.end_time)} Hrs Session</p>
                                        {/* <p className='ptitle'>50 Hrs Session</p> */}
                                        {data?.is_completed &&
                                            <Link to={'/shibir-inner'} > <p className='featurebtn zoom_in_out'>Earned Features</p></Link>
                                        }

                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    )
}

export default Journey_within